var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":12}},[_c('div',{staticClass:"dd-section-title"},[_vm._t("default")],2)])],1),_c('hr',{staticClass:"dd-section-line"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }